import { PmsSchedulesLocationComponent } from 'app/components/pms-schedules-location/PmsSchedulesLocationComponent'
import { usePmsSchedulesLocation } from 'app/components/pms-schedules-location/usePmsSchedulesLocation'

export const handle = {
  title: `PMS Schedules`,
  breadcrumb: `Schedules`,
}

export default function PMSSchedulesRoute() {
  const data = usePmsSchedulesLocation()
  return <PmsSchedulesLocationComponent {...data} />
}
